import React from 'react';
import { FormState } from './Aspects';

type Props = {
    formState: FormState[];
    currentAspectIndex: number;
};

const PreviewComp: React.FC<Props> = ({
    formState,
    currentAspectIndex,
}: Props) => {
    // Validar que formState no esté vacío
    if (!formState || formState.length === 0) {
        return (
            <div
                style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    marginTop: "0px",
                    backgroundColor: "#000",
                    color: "#fff",
                    textAlign: "center",
                }}
            >
                No hay datos para mostrar.
            </div>
        );
    }

    // Asegurarse de que currentAspectIndex esté dentro del rango válido
    const safeIndex = currentAspectIndex % formState.length;
    const currentAspect = formState[safeIndex];

    // Validar que currentAspect no sea undefined
    if (!currentAspect) {
        return (
            <div
                style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    marginTop: "0px",
                    backgroundColor: "#000",
                    color: "#fff",
                    textAlign: "center",
                }}
            >
                Índice de aspecto no válido.
            </div>
        );
    }

    return (
        <div
            style={{
                border: "1px solid #ccc",
                padding: "10px",
                marginTop: "0px",
                backgroundColor: "#000",
                minHeight: "120px",
                maxHeight: "180px"
            }}
        >
            <div
                key={safeIndex}
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {currentAspect.pictogram !== "none" && (
                    <img
                        src={currentAspect.pictogram}
                        alt="Pictogram"
                        style={{
                            width: "auto",
                            height: currentAspect.textSize * 5 + "px", // Altura igual a las tres líneas
                            marginRight: "10px"
                        }}
                    />
                )}
                <div style={{ flex: 1 }}>
                    {currentAspect.messages.map((message, i) => (
                        <p
                            key={i}
                            style={{
                                textAlign: currentAspect.textAlign,
                                fontSize: `calc(${currentAspect.textSize - 12}px + 1vh)`, // Adjust font size based on window width
                                color: currentAspect.textColor,
                                margin: "0",
                                textTransform: "uppercase"
                            }}
                        >
                            {message}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PreviewComp;